import React from 'react';

export default Illustration;

export enum IllustrationSize {
    XSmall = 'xsmall',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
    XLarge = 'xlarge',
    XXLarge = 'xxlarge',
}

export type IllustrationProps = {
    component?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    size?: IllustrationSize | number;
    style?: React.CSSProperties;
};

function Illustration({
    component: Component,
    size,
    style,
    ...props
}: IllustrationProps) {
    if (!Component) return null;

    return (
        <div
            className="Illustration"
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                fontStyle: 'normal',
                textAlign: 'center',
                textTransform: 'none',
                textRendering: 'optimizeLegibility',
                WebkitFontSmoothing: 'antialiased',
                ...style,
            }}
            {...props}
        >
            <Component
                width={size ? `${getIllustrationSizePx(size)}px` : '100%'}
                height={size ? `${getIllustrationSizePx(size)}px` : '100%'}
            />
        </div>
    );
}

function getIllustrationSizePx(size: IllustrationSize | number): number {
    switch (size) {
        case IllustrationSize.XSmall:
            return 75;
        case IllustrationSize.Small:
            return 100;
        case IllustrationSize.Medium:
            return 100;
        case IllustrationSize.Large:
            return 200;
        case IllustrationSize.XLarge:
            return 300;
        case IllustrationSize.XXLarge:
            return 350;
        default:
            return size;
    }
}
